import React, { useEffect, useState } from "react";

//STYLES
import "./rankingIndicator.css";

export default function RankingIndicator({
  promoterNumber,
  detractorNumber,
  neutralNumber,
}) {
  //STATES
  const [detractorSize, setDetractorSize] = useState(
    getSize(detractorNumber, promoterNumber, neutralNumber, "detractor", false)
  );
  const [neutralSize, setNeutralSize] = useState(
    getSize(detractorNumber, promoterNumber, neutralNumber, "neutral", false)
  );
  const [promoterSize, setPromoterSize] = useState(
    getSize(detractorNumber, promoterNumber, neutralNumber, "promoter", false)
  );

  //FUNCTIONS
  function getSize(
    detractorNumber,
    promoterNumber,
    neutralNumber,
    type,
    isUpdate = false
  ) {
    const values = [detractorNumber, promoterNumber, neutralNumber].filter(
      (value) => {
        return value;
      }
    );
    let lowerValue = null;
    if (values && values.length) {
      lowerValue = Math.min(...values);
    }
    if (lowerValue) {
      const detractorFlex = detractorNumber / lowerValue;
      const promoterFlex = promoterNumber / lowerValue;
      const neutralFlex = neutralNumber / lowerValue;

      switch (type) {
        case "detractor":
          if (isUpdate) {
            setDetractorSize(detractorFlex);
            return detractorFlex;
          } else {
            return detractorFlex;
          }
        case "promoter":
          if (isUpdate) {
            setPromoterSize(promoterFlex);
            return promoterFlex;
          } else {
            return promoterFlex;
          }
        case "neutral":
          if (isUpdate) {
            setNeutralSize(neutralFlex);
            return neutralFlex;
          } else {
            return neutralFlex;
          }
        default:
          return 0;
      }
    } else {
      if (isUpdate) {
        setDetractorSize(0);
        setNeutralSize(0);
        setPromoterSize(0);
        return 0;
      } else {
        return 0;
      }
    }
  }

  //USE EFFECTS
  useEffect(() => {
    getSize(detractorNumber, promoterNumber, neutralNumber, "detractor", true);
  }, [detractorNumber]);

  useEffect(() => {
    getSize(detractorNumber, promoterNumber, neutralNumber, "neutral", true);
  }, [neutralNumber]);

  useEffect(() => {
    getSize(detractorNumber, promoterNumber, neutralNumber, "promoter", true);
  }, [promoterNumber]);

  return (
    <div className="rankingIndicator__container">
      <div
        className="rankingIndicator__container--detractor"
        style={{ flex: detractorSize }}
      ></div>
      <div
        className="rankingIndicator__container--neutral"
        style={{ flex: neutralSize }}
      ></div>
      <div
        className="rankingIndicator__container--promoter"
        style={{ flex: promoterSize }}
      ></div>
    </div>
  );
}
